// WP-05 — "if it changes the URL, it is a link."
// Route-bound CTAs must be real <Link>/<a> elements so they are middle-clickable, open in a
// new tab, pass crawl authority, and announce as "link" to assistive tech. This renders a
// router Link (or a plain <a> for external/hash hrefs) with the house button vocabulary, so
// nobody reaches for <button onClick={() => navigate(...)}> to get button styling.
// Keep <button> for actions that do NOT navigate: modal openers, scroll-to-section, toggles.
import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";
import { BUTTON_BASE, BUTTON_SIZES, BUTTON_VARIANTS } from "../ui/primitives";

// Renders from ui/primitives Button's OWN exported recipe (BUTTON_BASE/VARIANTS/SIZES), so a
// link-shaped CTA can never drift from the button vocabulary. Links skip the disabled utilities
// (an <a> has no disabled state). `bare` skips the recipe entirely — bespoke hero/nav gradient
// CTAs pass their full styling.
const BASE =
  BUTTON_BASE + " focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2";

export default function ButtonLink({ to, href, bare = false, variant = "primary", size = "md", className, children, ...rest }) {
  const cls = bare
    ? cn("inline-flex items-center justify-center gap-2 select-none", className)
    : cn(BASE, BUTTON_VARIANTS[variant] || BUTTON_VARIANTS.primary, BUTTON_SIZES[size] || BUTTON_SIZES.md, className);
  if (to) {
    return (
      <Link className={cls} to={to} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <a className={cls} href={href} {...rest}>
      {children}
    </a>
  );
}
